import script from "./BotonAccion.vue?vue&type=script&setup=true&lang=js"
export * from "./BotonAccion.vue?vue&type=script&setup=true&lang=js"

import "./BotonAccion.vue?vue&type=style&index=0&id=9055be84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9055be84"]])

export default __exports__